import * as React from 'react';
import Flexbox from 'components/UI/FlexboxContainer';
import { Control, Controller } from 'react-hook-form';
import { IFormData } from 'data/Service';
import { SERVICE_CONSTANTS, SERVICE_FORM_FIELDS, SERVICE_FORM_RULES } from 'constants/service';
import { renderInput } from '../UI/RenderFields';
import { useServicePermissions } from 'hooks/useServicePermissions';

interface Props {
    control: Control<IFormData>;
    errors: any;
    watch: any;
    setError?: any;
    clearErrors?: any;
}

const ServiceGeneralDetails: React.FC<Props> = ({ control, errors}: Props) => {
    const { readOnly } = useServicePermissions();

        return (
            <Flexbox justifyContent='space-between' width='100%' padding='10px 0px' gap={'20px'}>
                {/* Service name, type, and SKU */}
                <Flexbox flexDirection='row' width='100%' gap={'10px'} >

                    {/* Service name field */}
                    <Controller
                        name={SERVICE_FORM_FIELDS.NAME}
                    control={control}
                    rules={SERVICE_FORM_RULES.SERVICE_NAME}
                    render={({ field }) => (
                        renderInput(field,
                            SERVICE_FORM_FIELDS.NAME,
                            SERVICE_CONSTANTS.SERVICE_NAME,
                            SERVICE_CONSTANTS.ENTER_SERVICE_NAME,
                            errors.name?.message,
                            !!errors.name,
                            false,
                            '',
                            readOnly
                        )
                    )}
                />

                {/* Service SKU field */}
                <Controller
                    name={SERVICE_FORM_FIELDS.SKU}
                    control={control}
                    rules={SERVICE_FORM_RULES.SERVICE_SKU}
                    render={({ field }) => (
                        renderInput(field,
                            SERVICE_FORM_FIELDS.SKU,
                            SERVICE_CONSTANTS.SERVICE_SKU,
                            SERVICE_CONSTANTS.ENTER_SERVICE_SKU,
                            errors.sku?.message,
                            !!errors.sku,
                            false,
                            '',
                            readOnly
                        )
                    )}
                />

            </Flexbox>


        </Flexbox>
    );
}

export default (ServiceGeneralDetails);

